import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'
import { heightButton } from '@/styles/mixins'
import {
  FontFamilyStyles,
  InputTextStyles,
  LegiaMedium
} from '@/styles/typography'
import { border, colors, transitions } from '@/styles/theme'

import { Field } from './Field'

// TODO: Refactor — remove unused styles
export const PhoneField = styled(Field)<{ $invalid: boolean }>`
  .react-tel-input {
    ${InputTextStyles};
    ${FontFamilyStyles};
    position: relative;
    width: 100%;
  }

  .react-tel-input :disabled {
    cursor: not-allowed;
  }

  .react-tel-input * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .react-tel-input .hide {
    display: none;
  }

  .react-tel-input .v-hide {
    visibility: hidden;
  }

  .react-tel-input .form-control {
    ${InputTextStyles};
    ${heightButton};

    position: relative;
    border-radius: ${border.radius};
    box-shadow: ${border.shadow};
    background-color: ${colors.white};
    border: 1px solid transparent;
    color: var(--main);
    transition: border-color ${transitions.base};
    width: 100%;
    outline: 0;
    padding: 15px 40px 15px 60px !important;

    ${mediaUp('lg')} {
      padding: 15px 40px 15px 80px !important;
      border-width: 2px;
    }

    .legia-warszawa & {
      ${LegiaMedium};
      color: var(--mainCustom);
      border-radius: 0;
    }
  }

  .react-tel-input .form-control:focus {
    border-color: var(--accentFirst);

    .legia-warszawa & {
      border-color: var(--accentFirstCustom);
    }
  }

  .react-tel-input .form-control {
    ${props => props.$invalid && `border-color: ${colors.darkCoral};`}
  }

  .react-tel-input .form-control:focus + div:before {
    color: #1976d2;
  }

  .react-tel-input .form-control.invalid-number {
    border: 2px solid ${colors.darkCoral};
  }

  .react-tel-input .form-control.invalid-number:focus {
    box-shadow: 0 0 0 1px ${colors.darkCoral};
  }

  .react-tel-input .form-control.invalid-number + div:before {
    content: 'Error';
    display: none;
    color: ${colors.darkCoral};
    width: 27px;
  }

  .react-tel-input .flag-dropdown {
    position: absolute;
    top: 14px;
    bottom: 0;
    left: 10px;
    padding: 0;
    background-color: transparent;
    border: none;

    ${mediaUp('lg')} {
      left: 20px;
    }
  }

  .react-tel-input .flag-dropdown:hover,
  .react-tel-input .flag-dropdown:focus {
    cursor: pointer;
  }

  .react-tel-input .flag-dropdown.open {
    z-index: 2;
  }

  .react-tel-input input[disabled] + .flag-dropdown:hover {
    cursor: default;
  }

  .react-tel-input input[disabled] + .flag-dropdown:hover .selected-flag {
    background-color: transparent;
  }

  .react-tel-input .selected-flag {
    outline: none;
    position: relative;
    width: 52px;
    height: 90%;
    border-radius: 3px 0 0 3px;
    padding-top: 0;
    padding-bottom: 0;
    padding-inline-start: 11px;
    padding-inline-end: 0;
  }

  .react-tel-input .selected-flag:focus .arrow {
    border-left-width: 4px;
    border-right-width: 4px;
    border-top: 5px solid #1976d2;
  }

  .react-tel-input .selected-flag .flag {
    position: absolute;
    top: 50%;
    margin-top: -12px;
  }

  .react-tel-input .selected-flag .arrow {
    position: relative;
    top: 50%;
    margin-top: -1px;
    left: 29px;
    width: 0;
    height: 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    border-top: 4px solid #555;

    html[lang^='ar'] & {
      right: 29px;
      left: unset;
    }
  }

  .react-tel-input .selected-flag .arrow.up {
    border-top: none;
    border-bottom: 4px solid #555;
  }

  .react-tel-input .country-list {
    outline: none;
    z-index: 1;
    list-style: none;
    position: absolute;
    padding: 0;
    margin: 10px 0 10px -1px;
    box-shadow: 1px 2px 18px rgba(0, 0, 0, 0.25);
    background-color: white;
    width: 300px;
    max-height: 220px;
    overflow-y: scroll;
    border-radius: 7px;
    top: 100%;
    left: 0;
  }

  .react-tel-input .country-list .flag {
    display: inline-block;
    position: absolute;
    left: 20px;
    top: 14px;

    html[lang^='ar'] & {
      right: 20px;
      left: unset;
    }
  }

  .react-tel-input .country-list .divider {
    padding-bottom: 5px;
    margin-bottom: 5px;
    border-bottom: 1px solid #ccc;
  }

  .react-tel-input .country-list .country {
    position: relative;
    padding-top: 12px;
    padding-bottom: 13px;
    padding-inline-start: 46px;
    padding-inline-end: 9px;
  }

  .react-tel-input .country-list .country .dial-code {
    color: #6b6b6b;
  }

  .react-tel-input .country-list .country:hover {
    background-color: #f1f1f1;
  }

  .react-tel-input .country-list .country.highlight {
    background-color: #f1f1f1;
  }

  .react-tel-input .country-list .flag {
    margin-inline-end: 7px;
    margin-top: 6px;
  }

  .react-tel-input .country-list .country-name {
    margin-inline-start: 6px;
  }

  .react-tel-input .country-list .search {
    z-index: 2;
    position: sticky;
    top: 0;
    background-color: #fff;
    padding-top: 10px;
    padding-bottom: 6px;
    padding-inline-start: 10px;
    padding-inline-end: 0;
  }

  .react-tel-input .country-list .search-emoji {
    display: none;
    font-size: 15px;
  }

  .react-tel-input .country-list .search-box {
    ${InputTextStyles};
    ${FontFamilyStyles};
    box-shadow: ${border.shadow};
    background-color: ${colors.white};
    border: 1px solid transparent;
    color: var(--main);
    transition: border-color ${transitions.base};
    border-radius: 15px;
    font-size: 15px;
    line-height: 15px;
    margin-inline-start: 6px;
    padding: 3px 10px 5px;
    outline: 0;
    height: 30px;

    ${mediaUp('lg')} {
      height: 45px;
    }
  }

  .react-tel-input .country-list .search-box:focus {
    border-color: var(--accentFirst);

    .legia-warszawa & {
      border-color: var(--accentFirstCustom);
    }
  }

  .react-tel-input .country-list .no-entries-message {
    padding: 7px 10px 11px;
    opacity: 0.7;
  }

  .react-tel-input .invalid-number-message {
    position: absolute;
    z-index: 1;
    font-size: 13px;
    left: 25px;
    top: -7px;
    background: #fff;
    padding: 0 5px;
    color: #de0000;

    html[lang^='ar'] & {
      left: unset;
      right: 25px;
    }
  }

  .react-tel-input .special-label {
    display: none;
    position: absolute;
    z-index: 1;
    top: -7px;
    left: 25px;
    background: white;
    padding: 0 5px;
    font-size: 13px;
    white-space: nowrap;

    html[lang^='ar'] & {
      left: unset;
      right: 25px;
    }
  }
`
